// extracted by mini-css-extract-plugin
module.exports = {"tokens":"relatedContent_tokens__DZ3Sk","onDark":"relatedContent_onDark__9kf62","relatedContent":"relatedContent_relatedContent__h4IBQ"};